import './global.js'
import Parse from 'parse';
import React from 'react';
import Singlepostoverly from "./Singlepostoverly.jsx";
import { Route, Link} from "react-router-dom";

//const Post = ({ match }) => <p>Bloop {match.params.id}</p>;
/*
class Post extends React.Component {
    render() {
    return (
        <div>
          <p>Bloop {this.props.match.params.id}</p>
        </div>

    );
  }
}*/


class Postsone extends React.Component {
      constructor(props) {
        super(props);

        Parse.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5", "sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw"); //PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY
        Parse.serverURL = "https://parse.joelskitchen.com/parse";
        //Parse.serverURL = "https://parsetest.joelskitchen.com/parse";

        var now = new Date();

        this.state = {
            postID: 0,
            postData: null,
            created_at: now.getTime(),
            comments: null,
            postImage: null,
            userImage: null,
            user: null,
            caption: null,
            likeCount: 0,
            saveCount: 0,
            commentCount: 0,
        };


        this.setState({postID: this.props.match.params.id});

        this.postID = this.props.match.params.id;

        this.queryForPostData();
    }

    queryForPostData() {
                console.log("QueryForPostData");

        var query = new Parse.Query('Photo');
        /*
        var isAdmin = false;
        if (Parse.User.current())
            isAdmin = Parse.User.current().get("isAdmin");

       //TEMP -- see all recipes
        if (!isAdmin)
          */
        query.equalTo("objectId", this.postID);

        query.include("user");
        query.include("image");
        query.include("thumbnail");
        query.include("likeCountNew");
        query.include("saveCount");
        query.include("commentcount");
        query.include("_created_at");
        query.include("createdAt");
        query.include("recipe");
        query.include("product");
        query.include("collabUser");
        query.include("collabUser.displayUsername");
        query.ascending("name");

        var self = this;

        query.first().then(function(result){
            if(result){
                console.log("Query found something");
                console.log(result);
                self.setState({postData: result});

                console.log("User: ", result.get("user"));
                console.log("Username: ", result.get("user").get("displayUsername"));
                console.log("User image: ", result.get("user").get("profilePictureSmall").url());
                console.log("Image: ", result.get("image").url());

                self.setState({user: result.get("user")});
                self.setState({userImage: result.get("user").get("profilePictureSmall").url()});
                self.setState({username: result.get("user").get("displayUsername")});
                self.setState({postImage: result.get("image").url()});
                self.setState({caption: result.get("caption")});
                self.setState({created_at: result.get("createdAt")});

                var likeCount = result.get("likeCountNew");
                var saveCount = result.get("saveCount");
                var commentCount = result.get("commentcount");
                
                if (!likeCount) likeCount = 0;
                if (!saveCount) saveCount = 0;
                if (!commentCount) commentCount = 0;

                self.setState({likeCount: likeCount});
                self.setState({saveCount: saveCount});
                self.setState({commentCount: commentCount});

                self.queryForComments();

                // If result was defined, the object with this objectID was found
                //promise.resolve(result);
            } else {
                console.log("No post found");
               // promise.resolve(null);
            }
        }, function(error){
                console.error("Error loading post Error: " + error);
                //promise.error(error);
        });
    }


    render() {

    var likesWord = "likes";
    var savesWord = "saves";
    var commentsWord = "comments";

    if (this.state.likeCount == 1) likesWord = "like";
    if (this.state.saveCount == 1) savesWord = "save";
    if (this.state.commentCount == 1) commentsWord = "comment";
    
    if (!this.state.postData)
    {
      return (
          <div>
          </div>

         );
    }
    return (
      <main className='single_card_wrapper'>
        <div className='container'>
          <div className='inner sticky_app_btn'>
            <div className='single_card'>
              <Singlepostoverly postData={this.state.postData} showComments="true" />
            </div>
            <div className='get-app cta_btn'>
              <div className='secondary-btn btn-wrp sml-btn'>
                <a href='javascript:void(0);' type="button" data-toggle="modal" data-target="#kitchenQrModal" title='Get app'>Get app</a>

               
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

class Posts1 extends React.Component {
    render() {
    return (
        <div className="App">
          <Route path="/postsone/:id" component={Postsone} />
        </div>

    );
  }
}

export default Posts1;



// WEBPACK FOOTER //
// ./src/postsone.jsx